import React__default from 'react';
import { sortData } from '../utils/sortUtils.js';
import Row from './Row.js';

/**
 * NonRowGroups - The lowest children rows of a parent row group
 * @param {object} props column definitions
 * @param {string} props.classesForColumns classes from columnDefs passed to cells
 * @param {any} props.columnDefs column definitions
 * @param {string} props.id unique id generated from parent
 * @param {boolean} props.isChildRowGroup true will prevent rendering, false will render children
 * @param {number} props.parentRowGroupIndex the index of the column def row group
 * @param {any} props.parentRows rows generated from parent
 * @param {string} props.expandedRowGroup the value of the selected parent from expansion
 * @returns {any}
 */

function NonRowGroups(_ref) {
  var classesForColumns = _ref.classesForColumns,
    columnDefs = _ref.columnDefs,
    id = _ref.id,
    isChildRowGroup = _ref.isChildRowGroup,
    parentRowGroupIndex = _ref.parentRowGroupIndex,
    parentRows = _ref.parentRows,
    expandedRowGroup = _ref.expandedRowGroup;
  var childRowGroupData = expandedRowGroup ? parentRows.filter(function (row) {
    return row[columnDefs[parentRowGroupIndex].field] === expandedRowGroup;
  }) : [];

  // Prevents row groups from rendering at the row level
  if (!expandedRowGroup || isChildRowGroup) {
    return null;
  }
  var sortedData = sortData(childRowGroupData, columnDefs, childRowGroupData);
  return sortedData.map(function (row, index) {
    var updatedId = "rowGroup-".concat(id, "-row-").concat(index);
    return /*#__PURE__*/React__default.createElement(Row, {
      singleRowData: row,
      classesForColumns: classesForColumns,
      id: updatedId,
      parentRowGroupIndex: parentRowGroupIndex,
      key: updatedId
    });
  });
}

export { NonRowGroups as default };
